import type { IconType } from 'react-icons';
import {
  LuArrowLeftRight,
  LuBuilding,
  LuBuilding2,
  LuCalendar,
  LuCalendarCheck,
  LuCalendarOff,
  LuCircleAlert,
  LuCircleUser,
  LuClipboardCheck,
  LuClipboardList,
  LuContact,
  LuFileSearch,
  LuGavel,
  LuGlobe,
  LuGraduationCap,
  LuLandmark,
  LuLayoutDashboard,
  LuLayoutGrid,
  LuLink,
  LuMap,
  LuMapPin,
  LuNetwork,
  LuScale,
  LuScrollText,
  LuSettings,
  LuTable,
  LuTrophy,
  LuShield,
  LuSquareCheck,
  LuTags,
  LuUser,
  LuUsers,
  LuWallet,
  LuWrench,
  LuFilePen,
  LuSun,
} from 'react-icons/lu';

const ITEM_ICONS: Record<string, IconType> = {
  Eventos: LuCalendar,
  Resumo: LuCalendar,
  'Cadastro de Eventos': LuCalendar,
  'Cadastro de Ausências': LuCalendar,
  'Eventos institucionais': LuCalendar,
  'Eventos / Ações': LuCalendar,
  'Regras de validação': LuSquareCheck,
  'Regras de Validação': LuSquareCheck,
  'Tabelas de Ações': LuTable,
  'Tabela de Eventos': LuTable,
  'Tabelas de Vínculos': LuTable,
  'Tabelas de Atuação': LuTable,
  'Tabelas de Atividades': LuTable,
  Pontuações: LuTrophy,
  Vínculos: LuLink,
  'Locais de Atuação': LuLink,
  'Cadastro de Defensores(as)': LuScale,
  'Afastamentos e Benefícios': LuCalendar,
  Movimentações: LuArrowLeftRight,
  'Pendentes e Enviadas': LuClipboardCheck,
  'Cadastro de Atividades': LuArrowLeftRight,
  'Tabela de Movimentações': LuTable,
  'Pesquisa de Atividades': LuFileSearch,
  'Todas as Movimentações': LuFileSearch,
  'Tipos de Movimentações': LuTags,
  Relatórios: LuScrollText,
  'Relatórios de atividades': LuScrollText,
  'Corregedoria (relatórios)': LuClipboardCheck,
  'Defensores (cadastro)': LuScale,
  Defensores: LuScale,
  'Folhas de frequência': LuCalendarCheck,
  'Folhas por mês': LuCalendarCheck,
  'Folhas por estagiário': LuCalendarCheck,
  'Folhas dos Estagiários': LuCalendarCheck,
  'Folhas do mês': LuCalendarCheck,
  Pendências: LuCircleAlert,
  'Instituições de Ensino': LuGraduationCap,
  'Processos seletivos': LuClipboardList,
  'Estagiários (cadastro)': LuUser,
  Estagiários: LuUser,
  Colaboradores: LuContact,
  Diretorias: LuBuilding,
  'Esferas de Atuação': LuGlobe,
  'Varas/Centrais': LuGavel,
  Defensorias: LuLandmark,
  Núcleos: LuNetwork,
  Setores: LuLayoutGrid,
  Funções: LuTags,
  'Funções e Cargos': LuTags,
  Comarcas: LuMapPin,
  Distritos: LuMap,
  'Fóruns/Unidades': LuBuilding2,
  Gastos: LuWallet,
  'Tipos de Gasto': LuTags,
  Papéis: LuShield,
  'Cadastros de pessoas': LuContact,
  Pessoas: LuContact,
  Auditorias: LuFileSearch,
  Configurações: LuSettings,
  'Painéis Gerenciais': LuLayoutDashboard,
  'Painéis liberados': LuLayoutDashboard,
  'Cadastro de Painéis': LuLayoutDashboard,
  'Bloqueios e Feriados': LuCalendarOff,
  Feriados: LuCalendarOff,
  'Folha Atual': LuCalendarCheck,
  'Minhas Folhas': LuCalendarCheck,
  'Meu perfil': LuCircleUser,
  'Meus relatórios': LuScrollText,
  'Meus Relatórios': LuScrollText,
  'Relatórios Mensais': LuScrollText,
  'Relatórios do Solar (dev)': LuSun,
  'Diretoria Regional': LuScale,
  Corregedoria: LuGavel,
  'Aprovação (diretoria)': LuSquareCheck,
  'PDF DPE': LuFilePen,
};

const GROUP_ICONS: Record<string, IconType> = {
  'Férias e eventos': LuCalendar,
  'Férias e benefícios': LuCalendar,
  Movimentações: LuArrowLeftRight,
  Atividades: LuCalendarCheck,
  'Cadastro de Relatórios': LuScrollText,
  'Locais de Atuação': LuLink,
  'Gestão de Estágios': LuCalendarCheck,
  Relatórios: LuScrollText,
  'Relatórios de atividades': LuScrollText,
  'Organizacionais': LuBuilding,
  Locais: LuMapPin,
  Escritório: LuWallet,
  Sistema: LuSettings,
  Supervisão: LuUsers,
  Pessoas: LuContact,
  'Recursos Humanos': LuUsers,
  Estagiários: LuCalendarCheck,
  Utilitários: LuWrench,
  'Painéis Gerenciais': LuLayoutDashboard,
};

export function getNavItemIcon(label: string): IconType {
  return ITEM_ICONS[label] ?? LuScrollText;
}

export function getNavGroupIcon(label: string): IconType {
  return GROUP_ICONS[label] ?? LuLayoutGrid;
}
